import React from 'react';
import classnames from 'classnames';
import {
  HeadingSizeTags,
  HubModule,
  HubModuleCTA,
  PropsWithTestId,
  TitleSizeType,
} from '../../../../../../types';
import { HubModuleWrapper } from '../../HubModuleWrapper';
import { HubModuleTypes } from '../../../../../../constants';
import { HTMLtoJSX } from '../../../../../../helpers';
import { CallToAction } from '../../../CallToActionGroup';
import styles from './AlertModule.module.scss';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectPageConfig } from '../../../../../../store/features/pageConfig';

export interface AlertModuleType extends HubModule {
  '@type': HubModuleTypes.AlertBanner;
  alertText: string;
  isLive: boolean;
  title: string;
  titleSize: TitleSizeType;
  link: HubModuleCTA;
  expiry?: {
    date: string;
    instant: string;
    time: string;
    timeZone: string;
  };
}

export interface AlertModuleProps {
  module: AlertModuleType;
}

export default function AlertModule({
  module: {
    '@type': type,
    isLive,
    title,
    titleSize = 'H2',
    alertText,
    link,
    elementId,
    visualStyle,
  },
  testId,
}: PropsWithTestId<AlertModuleProps>) {
  const { location } = useRootSelector(selectPageConfig);

  const gridClassName = classnames('col-xs-12 col-sm-12', {
    'col-lg-7': link.type,
  });

  const HeadingTag = HeadingSizeTags[titleSize];

  if (!isLive) return null;

  return (
    <HubModuleWrapper
      type={type}
      theme={visualStyle}
      elementId={elementId}
      testId={testId}
    >
      <div className="container">
        <div className="row middle-md">
          <div className={gridClassName}>
            {title && (
              <div className={styles.title}>
                <HeadingTag>{title}</HeadingTag>
              </div>
            )}
            {alertText && (
              <div className={styles.text}>
                {HTMLtoJSX(alertText, location)}
              </div>
            )}
          </div>
          {link?.type && (
            <div className="col-xs-12 col-sm-12 col-lg-offset-1 col-lg-4 end-lg">
              <CallToAction
                link={link}
                variant="contained"
                align="center"
                className={styles.ctaButton}
                ga4={{
                  module_type: type,
                }}
              />
            </div>
          )}
        </div>
      </div>
    </HubModuleWrapper>
  );
}

AlertModule.defaultProps = {
  testId: 'hub-alert-module',
};
